import { Chip, TableCell, TableRow, Typography } from "@mui/material";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { ContactOrder } from "../../shared/ordersAndInvoices/types";
import axios from "axios";
import { AddEditContactContext } from "./AddEditContactContext";
import { getStatusColor } from "../../../calendar/CalendarUtils";
import { format } from "date-fns";
import LoadingButton from "@mui/lab/LoadingButton";

interface IProps {
  order: ContactOrder;
  indexToProcess: number;
  setIndexToProcess: Dispatch<SetStateAction<number>>;
  index: number;
  mergeOrder: (orderToMerge: ContactOrder) => Promise<any>;
}
export default function MergedOrderRow({ order, indexToProcess, setIndexToProcess, index, mergeOrder }: IProps) {
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);

  const mergeOrderAndSetIndex = async () => {
    const data = await mergeOrder(order);
    setIsSuccessful(data);
    setIndexToProcess((i) => i + 1);
  };

  function formatDate(dateString: any) {
    return format(new Date(dateString), "dd.MM.yyyy p");
  }

  useEffect(() => {
    if (index === indexToProcess) {
      mergeOrderAndSetIndex();
    }
  }, [indexToProcess]);

  return (
    <>
      <TableRow
        key={order.orderNumber}
        sx={{
          backgroundColor: indexToProcess <= index ? "#ffffff" : isSuccessful ? "#E9FCD4" : "#FFE7D9"
        }}
      >
        <TableCell>
          <Typography variant="subtitle1">{order.orderNumber || ""}</Typography>
        </TableCell>
        <TableCell>{order.roleInOrder || ""}</TableCell>
        <TableCell>{formatDate(order.closingDate) || ""}</TableCell>
        <TableCell>
          <Chip
            variant="outlined"
            label={order.orderStatus}
            sx={{
              height: "24px",
              width: "100px",
              borderRadius: "6px",
              fontWeight: 600,
              borderColor: getStatusColor(order.orderStatus || "").color,
              color: getStatusColor(order.orderStatus || "").color
            }}
          />
        </TableCell>
        <TableCell>
          <LoadingButton loading={indexToProcess === index} />
        </TableCell>
      </TableRow>
    </>
  );
}
